import React from 'react';
import { PlusIcon } from 'lucide-react';
interface RepCounterProps {
  current: number;
  total: number;
  onIncrement: () => void;
  isActive: boolean;
  isPacing?: boolean;
  paceBeat?: boolean;
}
const RepCounter: React.FC<RepCounterProps> = ({
  current,
  total,
  onIncrement,
  isActive,
  isPacing = false,
  paceBeat = false
}) => {
  const percentage = current / total * 100;
  return <div className="text-center" data-id="element-43">
      <div className={`flex justify-center items-center mb-4 ${isPacing && paceBeat ? 'animate-pulse' : ''}`} data-id="element-44">
        <div className={`text-5xl font-bold mr-2 transition-all duration-200 ${isPacing && paceBeat ? 'text-purple-600 scale-110' : ''}`} data-id="element-45">
          {current}
        </div>
        <div className="text-2xl text-gray-500" data-id="element-46">/ {total}</div>
      </div>
      <div className="h-4 bg-gray-200 rounded-full overflow-hidden mb-6" data-id="element-47">
        <div className="h-full bg-green-500 transition-all duration-300 ease-in-out" style={{
        width: `${percentage}%`
      }} data-id="element-48"></div>
      </div>
      {isPacing && isActive && <div className={`text-lg font-medium mb-6 ${paceBeat ? 'text-purple-700 animate-pulse' : 'text-gray-600'}`} data-id="element-49">
          {paceBeat ? 'GO!' : 'Ready...'}
        </div>}
      {isActive && !isPacing && <button onClick={onIncrement} className="w-full py-6 bg-blue-500 hover:bg-blue-600 text-white text-xl font-medium rounded-xl flex items-center justify-center" disabled={current >= total} data-id="element-50">
          <PlusIcon size={24} className="mr-2" data-id="element-51" /> Count Rep
        </button>}
    </div>;
};
export default RepCounter;